import {h, render} from 'preact';

function Question({label}) {
    return (
        <div className="oQuiz__Question">
            <h2 className="oQuiz__Question__Headline aHeadline aHeadline--Secondary">{label}</h2>
        </div>
    )
}

export default Question
